var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConversationWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.542,
    height: 18.709,
    viewBox: "0 0 18.542 18.709",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Conversations_default_16px",
    transform: "translate(-369.069 -226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160568",
    "data-name": "Group 160568",
    transform: "translate(369.356 226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Conversations_Outline_24px",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1107",
    "data-name": "Rectangle 1107",
    width: 17.609,
    height: 18,
    fill: "#787f88",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3231",
    "data-name": "Group 3231",
    transform: "translate(0.463 0.896)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1108",
    "data-name": "Rectangle 1108",
    width: 9.921,
    height: 1.325,
    rx: 0.663,
    transform: "translate(2.897 3.41)",
    fill: "#787f88"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1109",
    "data-name": "Rectangle 1109",
    width: 6.652,
    height: 1.325,
    rx: 0.663,
    transform: "translate(2.9 7.082)",
    fill: "#787f88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M19.093,13.925a1.9,1.9,0,0,1-1.9,1.9H5.844L2.06,19.612V4.446a1.9,1.9,0,0,1,1.9-1.9H17.206a1.9,1.9,0,0,1,1.9,1.9V9.989",
    transform: "translate(-2.06 -2.55)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_129",
    "data-name": "Ellipse 129",
    cx: 0.504,
    cy: 0.504,
    r: 0.504,
    transform: "translate(16.53 8.932)",
    fill: "#787f88"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationWhiteIcon);
export default __webpack_public_path__ + "static/media/conversation-white-icon.6c4cc98f809800301a5f3444590bd177.svg";
export { ForwardRef as ReactComponent };